// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
  gap: 48px !important;
}
.story-card-section {
  border-left: 1px solid #ddd !important;
  padding-left: 8px !important;
}
.description {
  max-width: 600px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/community/PublicationProfile.vue","webpack://./PublicationProfile.vue"],"names":[],"mappings":"AAEA;EACE,oBAAA;ACDF;ADIA;EACE,sCAAA;EACA,4BAAA;ACDF;ADIA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.card-container {\n  gap: 48px !important;\n}\n\n.story-card-section {\n  border-left: 1px solid #ddd !important;\n  padding-left: 8px !important;\n}\n\n.description {\n  max-width: 600px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n",".card-container {\n  gap: 48px !important;\n}\n\n.story-card-section {\n  border-left: 1px solid #ddd !important;\n  padding-left: 8px !important;\n}\n\n.description {\n  max-width: 600px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
